

































import { Vue } from "vue-property-decorator";
import type { stadium_info, stadium_business, stadium_business_info, stadium_business_stock, stadium_business_increase, stadium_reduced_cost } from "@/@types/stadium/stadium"
import moment from "moment"
import Info from "@/views/invest/detail/form/stadium_info_form.vue"
import Business from "@/views/invest/detail/form/business.vue"
import BusinessInfo from "@/views/invest/detail/form/business_info.vue"
import BusinessTime from "@/views/invest/detail/form/business_time.vue"
import BusinessNew from "@/views/invest/detail/form/business_new_time.vue"
import ReducedCost from "@/views/invest/detail/form/stadium_reduced_cost_form.vue"
import Maintenance from "@/views/invest/detail/form/maintenance.vue"
import Registration from "@/views/invest/detail/form/registration.vue"
import Cooperation from "@/views/invest/detail/form/cooperation.vue"
import Appointment from "@/views/invest/detail/form/appointment.vue"
import Qualification from "@/views/invest/detail/form/qualification.vue"
import StadiumGround from "@/views/invest/detail/form/stadium_ground.vue"
import StadiumPhoto from "@/views/invest/detail/form/stadium_photo.vue"
import Correct from "@/views/invest/detail/form/correct.vue"

export default Vue.extend({
  name: "StadiumEstimateInfo",
  components: {
    Info,
    Business,
    BusinessInfo,
    BusinessTime,
    BusinessNew,
    ReducedCost,
    Maintenance,
    Registration,
    Cooperation,
    Appointment,
    Qualification,
    StadiumGround,
    StadiumPhoto,
    Correct
  },
  props: {
    id: { type: String, default: "" },
  },
  data() {
    return {
      stadium: {
        id             : "",
        name           : "",
        status         : "",
        status_logs    : [],
        estimate_logs  : [],
        estimate_status: "0",
        confirm_status : "0",
        cooperate_info : {
          business_finance_info: []
        },
      } as any,
      record : {} as any,
      correct: {} as any,
      /* 评估状态 */
      estimate_status: [
        { value: 0, label: "未开始", icon: "clock-circle", status: "#f60" },
        { value: 1, label: "审核中", icon: "clock-circle", status: "#10aeff" },
        { value: 2, label: "已通过", icon: "check-circle", status: "#4cd964" },
        { value: 3, label: "未通过", icon: "close-circle", status: "#f6383a" },
        { value: 4, label: "已撤销", icon: "clock-circle", status: "#909399" }
      ],
      /* 合作状态 */
      confirm_status: [
        { value: 0, label: "未开始", icon: "clock-circle", status: "#f60" },
        { value: 1, label: "审核中", icon: "clock-circle", status: "#10aeff" },
        { value: 2, label: "已通过", icon: "check-circle", status: "#4cd964" },
        { value: 3, label: "未通过", icon: "close-circle", status: "#f6383a" },
        { value: 4, label: "已撤销", icon: "clock-circle", status: "#909399" }
      ],
      editable        : false,
      stadium_info    : {} as stadium_info,
      stadium_business: {} as stadium_business,
      business_info   : {} as stadium_business_info,
      business_time   : {} as stadium_business_stock,
      business_new    : {} as stadium_business_increase,
      reduced_cost    : {} as stadium_reduced_cost
    }
  },
  methods: {
    async get_info() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        if (data.cooperate_info.open_time != "") data.cooperate_info.open_time = moment(data.cooperate_info.open_time, "YYYY-MM-DD").format("YYYY-MM-DD")
        if (data.confirm_status == "2") {
          const correct = await this.$store.dispatch("invest_correct/info", { estimate_id: this.id, op: 1 });
          if (correct.Code == 200) {
            const correct_data = correct.Data
            if (correct_data.status < 2) {
              if (Object.prototype.hasOwnProperty.call(correct_data, "open_time")) correct_data.open_time = moment(correct_data.open_time, "YYYY-MM-DD").format("YYYY-MM-DD")
              this.record  = correct_data
              this.correct = correct_data
            }
          }
        }
        this.stadium = data
        this.handleStadiumInfo(data.cooperate_info)
        this.handleStadiumnBusiness(data.cooperate_info)
        this.handleStadiumBusinessInfo(data.cooperate_info)
        this.handleBusinessTime(data.cooperate_info)
        this.handleBusinessNewTime(data.cooperate_info)
        this.handleReducedCost(data.cooperate_info)
        this.handleMaintenance(data.cooperate_info)
        this.handleRegistration(data.cooperate_info)
        this.handleCooperation(data.cooperate_info)
        this.handleAppointment(data.cooperate_info)
        this.handleQualification(data.cooperate_info)
        this.handleStadiumGround(data.cooperate_info)
        this.handleStadiumPhoto(data.cooperate_info)
      }
    },
    /* 处理场馆信息 */
    handleStadiumInfo(data: any) {
      this.stadium_info = {
        name              : data.name,
        area_name         : data.area_name,
        province_id       : data.province_id,
        city_id           : data.city_id,
        county_id         : data.county_id,
        addr              : data.addr,
        rent_run_years    : data.rent_run_years,
        rent_surplus_years: data.rent_surplus_years,
        open_time         : data.open_time,
        rent_type         : data.rent_type,
        stadium_size      : data.stadium_size,
        ground_count      : data.ground_count,
        other_item        : data.other_item,
        other_size        : data.other_size,
      }
      const info = this.$refs.info as any
      info.init()
    },
    /* 处理经营主体 */
    handleStadiumnBusiness(data: any) {
      this.stadium_business = {
        enterprise_name        : data.enterprise_name,
        credit_code            : data.credit_code,
        legal_representative   : data.legal_representative,
        legal_phone            : data.legal_phone,
        legal_email            : data.legal_email,
        principal_name         : data.principal_name,
        principal_phone        : data.principal_phone,
        principal_email        : data.principal_email,
        publicity_material_addr: data.publicity_material_addr,
      }
      const business = this.$refs.business as any
      business.init()
    },
    /* 处理主要营业信息 */
    handleStadiumBusinessInfo(data: any) {
      this.business_info = {
        business_time_a      : data.business_time_a,
        business_time_p      : data.business_time_p,
        business_time_o      : data.business_time_o,
        work_days_price_low  : data.work_days_price_low,
        work_days_price_high : data.work_days_price_high,
        business_bill_count  : data.business_bill_count,
        business_bill_hour   : data.business_bill_hour,
        business_month_cost  : data.business_month_cost,
        business_finance_info: data.business_finance_info,
      }
      const info = this.$refs.business_info as any
      info.init()
    },
    /* 处理新增营业时间 */
    handleBusinessNewTime(data: any) {
      this.business_new = {
        business_time_new     : data.business_time_new,
        business_time_new_hour: data.business_time_new_hour,
      }
      const business = this.$refs.business_new as any
      business.init()
    },
    /* 处理营业存量 */
    handleBusinessTime(data: any) {
      this.business_time = {
        business_time     : data.business_time,
        business_time_hour: data.business_time_hour,
      }
      const info = this.$refs.business_time as any
      info.init()
    },
    /* 降本收益 */
    handleReducedCost(data: any) {
      this.reduced_cost = {
        save_payment    : data.save_payment,
        approval_payment: data.approval_payment,
      }
      const cost = this.$refs.reduced_cost as any
      cost.init()
    },
    /* 运维费 */
    handleMaintenance(data: any) {
      const maintenance = this.$refs.maintenance as any
      maintenance.init(data)
    },
    handleRegistration(data: any) {
      const registration = this.$refs.registration as any
      registration.init(data)
    },
    handleCooperation(data: any) {
      const cooperation = this.$refs.cooperation as any
      cooperation.init(data)
    },
    handleAppointment(data: any) {
      const appointment = this.$refs.appointment as any
      appointment.init(data)
    },
    handleQualification(data: any) {
      const qualification = this.$refs.qualification as any
      qualification.init(data)
    },
    handleStadiumGround(data: any) {
      const stadium_ground = this.$refs.stadium_ground as any
      stadium_ground.init(data)
    },
    handleStadiumPhoto(data: any) {
      const stadium_photo = this.$refs.stadium_photo as any
      stadium_photo.init(data)
    },
    start_correct() {
      if (this.record && this.record.status == 1) {
        this.$info({ content: "纠错审核中，暂无法纠错" })
      } else {
        this.$confirm({
          content: "确定进行纠错？",
          onOk   : () => { this.editable = true }
        })
      }
    },
    modify(params: any) {
      const origin = this.$deep_copy(this.stadium.cooperate_info)
      for (const key in origin) {
        if (Object.prototype.hasOwnProperty.call(origin, key) && Object.prototype.hasOwnProperty.call(params, key)) {
          let compare = origin[key]
          if (key == "registration_urls") compare = compare.join(",")
          if (key == "business_month_cost" || key == "business_finance_info" || key == "business_time") compare = compare.join(";")
          if (params[key] != compare) {
            this.correct[key] = params[key]
          } else delete this.correct[key]
        }
      }
      this.correct.estimate_id = this.id
      this.correct.op = 1
    },
    async submit() {
      this.editable = false
      const correct = this.$refs.correct as any
      correct.open(this.id, 1)
    }
  },

  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.get_info();
        })
      }
    }
  }
})

